import { styled } from "styled-components";

export const SetColorPrimary = styled.div`
  color: ${({ theme }) => theme.colors.fillPrimary};
`;
